/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Volume2 = [
  "svg",
  defaultAttributes,
  [
    ["polygon", { points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5" }],
    ["path", { d: "M15.54 8.46a5 5 0 0 1 0 7.07" }],
    ["path", { d: "M19.07 4.93a10 10 0 0 1 0 14.14" }]
  ]
];

export { Volume2 as default };
//# sourceMappingURL=volume-2.js.map
